import React from "react";

const Edit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.99854 17.25V21H6.74854L17.8085 9.94L14.0585 6.19L2.99854 17.25ZM5.91854 19H4.99854V18.08L14.0585 9.02L14.9785 9.94L5.91854 19ZM20.7085 5.63L18.3685 3.29C18.1685 3.09 17.9185 3 17.6585 3C17.3985 3 17.1485 3.1 16.9585 3.29L15.1285 5.12L18.8785 8.87L20.7085 7.04C21.0985 6.65 21.0985 6.02 20.7085 5.63Z"
        fill="white"
      />
    </svg>
  );
};

export default Edit;
